import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import InpcList from 'inpc/components/list';

const { Form } = Common;

const InpcListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <InpcList.Header
        companyId={company.id}
        canAdd={permissions["acl.inpc.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.control_panel') + ' > ' + t('inpc.inpc_title')}
          icon={'money'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.inpc.add'] && (
                <Form.Link to={`/companies/${company.id}/inpc/add`} className="btn btn-info">
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <InpcList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <InpcList.Table
              company={company}
              permissions={permissions}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </InpcList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(InpcListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/InpcListView.js